require('./bootstrap');
require('./bwpublisher');

$(function () {
	// Overlay

	$('.overlay, [data-action="close-modal"]').on('click', function () {
		$('.overlay.active, .modal.active').removeClass('active');
	});

	// Mobile Nav

	$('.toggle-nav').on('click', function () {
		$('button.toggle-nav, header nav, .nav-overlay').toggleClass('active');
	});

	$('header nav button').on('click', function () {
		$(this).toggleClass('active').siblings('.container, ul').slideToggle(250);
	});

	// Desktop Nav

	// -- On click version
	$('header nav ul li ul li .has-child').on('click', function () {
		let $newH = $(this).siblings('ul').height();

		if ($(this).hasClass('active')) {
			$(this).closest('.row').height($newH);
		} else {
			$(this).closest('.row').removeAttr('style');
		}
	});

	$('header nav > ul > li > .has-child').on('click', function () {
		$('.nav-overlay').toggleClass('active');
	});

	$('.nav-overlay').on('click', function () {
		if ($(window).width() >= 770) {
			$(this).add('header nav .has-child').removeClass('active').siblings('.container, ul').removeClass('active');
		} else {
			$(this).add('button.toggle-nav, header nav').removeClass('active');
		}
	});

	let $windowWidth = $(window).width();

	$(window).on('resize', function () {
		if ($windowWidth < 770 && $(window).width() >= 770) {
			$('header button.active, header nav.active').removeClass('active');
			$('header nav .container[style*="display"], header nav ul[style*="display"]').css('display', '');
		}

		if ($windowWidth >= 770 && $(window).width() < 770) {
			$('header nav .active').removeClass('active');
			$('.row[style*="height"]').css('height', '');
		}

		$windowWidth = $(window).width();
	});

	// Search

	$('header .search').on('click', function () {
		if ($('header nav > ul > li > .has-child.active').length > 0) {
			$('header nav > ul > li > .has-child.active').trigger('click');
		}
		$(this).add('#header-search').toggleClass('active');
	});

	// Subscribe

	// let $hideSubscribe = localStorage.getItem('hideSubscribe');

	// $('.subscribe .close').on('click', function () {
	// 	localStorage.setItem('hideSubscribe', 'hide');

	// 	$('.subscribe').removeClass('active');
	// 	setTimeout(function () {
	// 		$('.subscribe-button').addClass('active');
	// 	}, 1000);
	// });

	$('.subscribe-button').on('click', function () {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'sign_up_form',
		});

		// $('.subscribe, .subscribe-button').toggleClass('active');
	});

	// if ($hideSubscribe !== 'hide') {
	// 	$('.subscribe').addClass('active')
	// } else {
	// 	$('.subscribe-button').addClass('active');
	// }

	// Home

	$('.home-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		autoplay: false,
		autoplaySpeed: 5000,
		speed: 2000,
	});

	$('.featured-shows.slider .shows').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 649,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 899,
				settings: {
					slidesToShow: 3,
				},
			},
		],
	});

	$('#single-product-image-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		cssEase: 'linear',
		autoplay: true,
		autoplaySpeed: 5000,
	});

	$('#single-product-image-slider-nav').slick({
		slidesToShow: 8,
		slidesToScroll: 1,
		asNavFor: '#single-product-image-slider',
		focusOnSelect: true,
		arrows: false,
		dots: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	});

	// Main

	pinFooter();

	let $formErrors = $('form:has(.error:not(:empty))');
	if ($formErrors.length) {
		$formErrors[0].scrollIntoView({
			block: 'center'
		});
	}
});

// Functions

function jumpTo(target, options) {
	$(target)[0].scrollIntoView(options);
}

function pinFooter() {
	let $contentHeight = 0;

	// Don't include the header, as the .page-header accounts for this
	if ($('header').length) {
		$contentHeight += $('header').outerHeight(true);
	}

	if ($('.page-header').length) {
		$contentHeight += $('.page-header').outerHeight(true);
	}

	if ($('.footer').length) {
		$contentHeight += $('.footer').outerHeight(true);
	}

	if ($('.legal').length) {
		$contentHeight += $('.legal').outerHeight(true);
	}

	// Dynamically calculate the height for all visible siblings
	// $('main').siblings(':visible').each(function() {
	//     if ($(this).css('opacity') > 0) {
	//         $contentHeight += $(this).outerHeight(true);
	//     }
	// });

	$('main').css('min-height', 'calc(100vh - ' + $contentHeight + 'px)');
}

// Arrow down - Events Page

// $('.fullpage').fullpage({
// 	menu: '#page',
// 	fixedElements: '.site-header, .site-footer',
// 	hybrid: true,
// 	autoScrolling: false,
// 	bigSectionsDestination: top,
// 	fitToSection: false,
// 	controlArrows: true
// });

$(document).on('click', 'a.arrow.down', function (e) {
	e.preventDefault();
	$.fn.fullpage.moveSectionDown();
});

// Overlay

export const showOverlay = (content, scheme = null) => {
	var id = $(content).attr('id');
	var close = $('#close-overlay-template').html();

	$(content).wrap("<div id='overlay'></div>");
	if (scheme) {
		$('#overlay').addClass(scheme);
	}
	$(close).appendTo($('#overlay'));
	$('#overlay a.close').attr('id', 'close-overlay');
	$(content).addClass('active');
	lockPage(true);
	var handler = function (event) {
		if (event.which === 27) {
			$('a#close-overlay').trigger('click');
		}
	};
	document.addEventListener('keydown', handler);
	$(document).on('click', 'a#close-overlay', function () {
		document.removeEventListener('keydown', handler);
		$('a#close-overlay').remove();
		$('#overlay > #' + id).unwrap();
		$(content).removeClass('active');
		$('#site-menu').hide();
		lockPage(false);
	});
};

// -- Homepage Shows tab

$(function () {
	var activeIndex = $('.active').index(),
		$contentlis = $('.tab-contents li'),
		$tabslis = $('.tab-panel li');

	// Show content of active tab on loads
	$contentlis.eq(activeIndex).show();

	$('.tab-panel').on('click', 'li', function (e) {
		var $current = $(e.currentTarget),
			index = $current.index();

		$tabslis.removeClass('active');
		$current.addClass('active');
		$contentlis.hide().eq(index).show();
	});
});

$(function () {
	let $hash = window.location.hash,
		$tar = $($hash + '-shows-tab');

	if ($tar.length) {
		$tar.trigger('click');
		$tar.closest('section')[0].scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		});
	}
});

// Textfill jquery for Show name
$(function () {
	$('.text-fill').textfill({ maxFontPixels: 18, explicitHeight: 60 });
});


// Use the URL to expand an Accordion entry
$(function () {
	var hash = window.location.hash;

	if (hash) {
		var element = $(hash);

		if (element.length) {
			element.trigger('click');
		}
	}
});
